module.exports = "ngb-modal-window .modal-dialog {\n  max-width: 800px;\n}\n.actions{\n  margin-top: 1rem;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/flights/single/flight.component.css
// module id = ./src/app/flights/single/flight.component.css
// module chunks = main